const deptData = {
    "code": 200,
    "msg": null,
    "data": [
        {
            "id": 1,
            "createBy": "admin",
            "createTime": "2021-07-08T11:35:22.000+0000",
            "lastUpdateBy": null,
            "lastUpdateTime": null,
            "name": "同望",
            "parentId": null,
            "orderNum": 0,
            "delFlag": 0,
            "children": [],
            "parentName": null,
            "level": 0
        },
        {
            "id": 2,
            "createBy": "admin",
            "createTime": "2021-07-08T11:35:55.000+0000",
            "lastUpdateBy": null,
            "lastUpdateTime": null,
            "name": "test",
            "parentId": null,
            "orderNum": 1,
            "delFlag": 0,
            "children": [
                {
                    "id": 4,
                    "createBy": "admin",
                    "createTime": "2021-07-08T11:37:03.000+0000",
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "name": "aa",
                    "parentId": 2,
                    "orderNum": 0,
                    "delFlag": 0,
                    "children": [
                        {
                            "id": 8,
                            "createBy": "admin",
                            "createTime": "2021-07-08T11:38:10.000+0000",
                            "lastUpdateBy": null,
                            "lastUpdateTime": null,
                            "name": "技术部",
                            "parentId": 4,
                            "orderNum": 0,
                            "delFlag": 0,
                            "children": [],
                            "parentName": "aa",
                            "level": 2
                        }
                    ],
                    "parentName": "test",
                    "level": 1
                }
            ],
            "parentName": null,
            "level": 0
        }
    ]
};
export default deptData;


// WEBPACK FOOTER //
// ./src/mock/modules/dept/deptData.js